<div class="container-box error-screen">
  <section class="shadowbox">
    <h1>Error !</h1>
    <p>{{ errMessage }}</p>
  </section>
</div>
